import React from 'react';
import { render } from 'react-dom';
import { Router as BrowserRouter } from 'react-router-dom';
import { createTheming } from '@callstack/react-theme-provider';

import MainTheme from 'themes/Main';
import history from 'utils/history';
import App from 'app';

import '@fortawesome/fontawesome-free/css/all.min.css';
import 'bootstrap-css-only/css/bootstrap.min.css';
import 'mdbreact/dist/css/mdb.css';
import './index.css';

const { ThemeProvider } = createTheming({ ...MainTheme });

const root = document.querySelector('#root');

render(
  <ThemeProvider>
    <BrowserRouter history={history}>
      <App />
    </BrowserRouter>
  </ThemeProvider>,
  root,
);
